import Vue from 'vue';

export default {
  state: {
    delinquency_status: [],
    tranche_status: [],
  },
  getters: {
    delinquency_status: state => state.delinquency_status,
    tranche_status: state => state.tranche_status,
  },
  mutations: {
    delinquency(state, data) {
      state.delinquency_status = data;
    },
    tranche(state, data) {
      state.tranche_status = data;
    },
  },
  actions: {
    getDelinquency({ commit }) {
      return Vue.axios.get('containment-states/deliquency').then((response) => {
        const delinquency = response.data.delinquency_status;
        commit('delinquency', delinquency);
      });
    },
    getTranche({ commit }) {
      return Vue.axios.get('containment-states/tranche').then((response) => {
        const tranche = response.data.tranche_status;
        commit('tranche', tranche);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/containment-states.js